import { showNotification } from '@/plugins/notification';

import router from '../../router';

export default {
  async getMe({ commit }) {
    if (!commit) return;

    try {   
      let response = await fetch(`/api/users/me`);
      let profile = await response.json();
      if (!profile.weighInThresholds?.[0]) {  
        let arr = [1, 2, 3, 4, 5];
        arr.forEach((item) => {
          profile.weighInThresholds?.push({ threshold: "off" });
        });
      }
      if (profile.statusCode === 401 || profile.statusCode === 403) {
        localStorage.removeItem("user");
        commit("setAuthStatus", false);
      } else {        
        localStorage.setItem("user", JSON.stringify(profile));
        commit("setUserData", profile);
        commit("setAuthStatus", true);
      }
      return profile;
    } catch (err) {
      console.error(err);
    }
  },
  signUp({ commit }, { phone, password }) {
    try {
      fetch(`/api/users/signup`, {
        method: "POST",
        body: JSON.stringify({
          phone,
          password,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then(async (data) => {
          if (data.error) {
            console.log("error", data.message);
          } else {
            let response = await fetch(`/api/users/${data.id}`);
            let profile = await response.json();
            localStorage.setItem("user", JSON.stringify(profile));
            commit("setUserData", profile);
            commit("setAuthStatus", true);
            router.push("/");
          }
        });
    } catch (error) {
      console.log("error", error);
    }
  },
  logIn({ commit }, { phone, password }) {
    try {
      fetch(`/api/auth/login`, {
        method: "POST",
        body: JSON.stringify({
          phone,
          password,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then(async (data) => {
          if (data.error) {
            console.log("error", data.message);
          } else {
            if (!data.satusCode) {
              commit("setAuthStatus", true);
              let response = await fetch(`/api/users/${data.id}`);
              let profile = await response.json();
              if (!profile.weighInThresholds[0]) {
                let arr = [1, 2, 3, 4, 5];
                arr.forEach((item) => {
                  profile.weighInThresholds.push({ threshold: "off" });
                });
              }
              localStorage.setItem("user", JSON.stringify(profile));
              commit("setUserData", profile);
              router.push("/");
            } else {
              commit("setUserDataError", data);
            }
          }
        });
    } catch (error) {
      console.log("error", error);
      commit("setUserDataError", error);
    }
  },
  async logOut({ commit }, error) {
    let response = await fetch(`/api/auth/logout`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response.ok || response.status === 403) {
      commit("setAuthStatus", false);
      let data = null;
      localStorage.removeItem("activeTab");
      localStorage.removeItem("user");
      localStorage.removeItem("isFirstLogin");
      commit("setProfile", data);
      commit("setUserData", data);
      router.push("/");
    }
  },

  async sendSmsCode({ commit }, { phone, captchaToken }) {
    try {
      const response = await fetch(`/api/auth/login-sms/send`, {
        method: "POST",
        body: JSON.stringify({ phone }),
        headers: {
          "Content-Type": "application/json",
          "X-Captcha-Token": captchaToken || "",
        },
      });
      if (response.status === 204) {
        commit("setShowSmsCodeInput", true);
        return {
          message: "Success",
          status: "success",
        };
      } else {
        const data = await response.json();
        console.log("error", data.message);
        return {
          message: data.message,
          status: "error",
        };
      }
    } catch (error) {
      console.log("error", error);
      return {
        message: "Server error",
        status: "error",
      };
    }
  },
  async verifySmsCode(
    { commit },
    { phone, code, username, firstName, lastName }
  ) {
    try {
      const requestData = {
        phone,
        code,
        ...(username && { username }),
        ...(firstName && { firstName }),
        ...(lastName && { lastName }),
      };
      const response = await fetch(`/api/auth/login-sms/check`, {
        method: "POST",
        body: JSON.stringify(requestData),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      if (data.statusCode === 409) {
        commit("setUserDataError", data.message);
        return {
          status: "error",
          usernameTaken: true,
          message: data.message,
        };
      }
      if (data.error) {
        console.log("error", data.message);
        commit("setUserDataError", data.message);
        return {
          status: "error",
          message: data.message,
        };
      }
      if (!data.statusCode) {
        let response = await fetch(`/api/users/${data.id}`);
        let profile = await response.json();
        if (!profile.weighInThresholds[0]) {
          let arr = [1, 2, 3, 4, 5];
          arr.forEach((item) => {
            profile.weighInThresholds.push({ threshold: "off" });
          });
        }
        localStorage.setItem("user", JSON.stringify(profile));
        localStorage.removeItem("userPhoneX");
        commit("setUserData", profile);
        commit("setAuthStatus", true);
        return {
          status: "success",
          message: "",
        };
      } else {
        commit("setUserDataError", data);
        return {
          status: "error",
          message: data.message,
        };
      }
    } catch (error) {
      console.log("error", error);
      commit("setUserDataError", error.message);
      return {
        status: "error",
        message: error.message,
      };
    }
  },
  async logInWithX({ commit }, { oauthToken, oauthVerifier }) {
    try {
      let response = await fetch(`/api/users/connect-x`, {
        method: "POST",
        body: JSON.stringify({
          oauthToken,
          oauthVerifier,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (data.error) {
        console.log("error", data.message);
        localStorage.removeItem("oauthToken");
        localStorage.removeItem("oauthVerifier");
        localStorage.setItem("isPostToX", false);
        commit("setUserDataError", data.message);
        return {
          status: "error",
          message: data.message,
        };
      }
      if (!data.statusCode) {
        let response = await fetch(`/api/users/${data.id}`);
        let profile = await response.json();
        if (!profile.weighInThresholds[0]) {
          let arr = [1, 2, 3, 4, 5];
          arr.forEach((item) => {
            profile.weighInThresholds.push({ threshold: "off" });
          });
        }
        localStorage.setItem("user", JSON.stringify(profile));
        localStorage.removeItem("oauthToken");
        localStorage.removeItem("oauthVerifier");
        localStorage.setItem("isPostToX", true);
        router.push("/");
        showNotification(
          "success",
          `X Account Connected!`,
          "Your X account has been successfully connected. Your posts will now be automatically published to X.",
          7000
        );
        commit("setUserData", profile);
        return {
          status: "success",
          message: "",
        };
      } else {
        commit("setUserDataError", data);
        return {
          status: "error",
          message: data.message,
        };
      }
    } catch (error) {
      console.log("error", error);
      commit("setUserDataError", error.message);
      return {
        status: "error",
        message: error.message,
      };
    }
  },

  async fetchDisconnectX({ commit }) {
    try {
      let response = await fetch(`/api/users/disconnect-x`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (!data.statusCode) {
        let response = await fetch(`/api/users/${data.id}`);
        let profile = await response.json();
        if (!profile.weighInThresholds[0]) {
          let arr = [1, 2, 3, 4, 5];
          arr.forEach((item) => {
            profile.weighInThresholds.push({ threshold: "off" });
          });
        }
        localStorage.setItem("user", JSON.stringify(profile));
        showNotification(
          "success",
          `X Account Disconnected`,
          "Your X account has been disconnected. Posts will no longer be published to X.",
          7000
        );
        commit("setUserData", profile);
        return data;
      } else {
        commit("setUserDataError", data);
        return data;
      }
    } catch (error) {
      console.log("error", error);
      commit("setUserDataError", error.message);
    }
  },

  async addAuthStatus({ commit }, status) {
    commit("setAuthStatus", status);
  },
  async authWithX({ commit }) {
    try {
      const response = await fetch(`/api/auth/login-x/request-token`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (data.error) {
        console.log("error", data.message);
        commit("setUserDataError", data.message);
      }
      if (!data.statusCode) {
        document.location.href = `https://api.x.com/oauth/authenticate?oauth_token=${data.oauthToken}`;
      } else {
        commit("setUserDataError", data);
      }
    } catch (error) {}
  },
  async deleteCurrentUser({ commit }, { reason }) {
    try {
      const response = await fetch(`/api/users/me`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: reason ? JSON.stringify({ reason }) : undefined,
      });
      if (!response.ok) {
        const errorData = await response.json();
        console.error("error:", errorData.message);
        throw new Error(errorData.message);
      }
      console.log("User deletion successful");
    } catch (error) {
      console.log("error", error);
      throw error;
    }
  },

  resetShowSmsCodeInput({ commit }) {
    commit("setShowSmsCodeInput", false);
  },
};
